module.exports = __webpack_public_path__ + "img/downloads-icon.727a59b9.svg";